import * as Sentry from '@sentry/react';
import { UIProvider } from 'moh-ui';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { RecoilRoot } from 'recoil-next';
import AppRoutes from './AppRoutes';
import ErrorBoundary from './components/HOCs/errorBoundary';
import { AuthProvider } from './hooks/useAuth';
import './styles/App.css';
import '@mantine/dates/styles.css';
const queryClient = new QueryClient();

function App() {
   return (
      <Sentry.ErrorBoundary>
         <ErrorBoundary>
            <UIProvider>
               <RecoilRoot>
                  <Toaster />
                  <Router>
                     <QueryClientProvider client={queryClient}>
                        <AuthProvider>
                           <AppRoutes />
                        </AuthProvider>
                     </QueryClientProvider>
                  </Router>
               </RecoilRoot>
            </UIProvider>
         </ErrorBoundary>
      </Sentry.ErrorBoundary>
   );
}

export default App;
